// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetInvoiceResponse = App.Http.Responses.Invoice.GetInvoiceResponse;
import GetInvoicesRequest = App.Http.Requests.Invoice.GetInvoicesRequest;
import GetInvoicesResponse = App.Http.Responses.Invoice.GetInvoicesResponse;
import StoreInvoiceRequest = App.Http.Requests.Invoice.StoreInvoiceRequest;
import UpdateInvoiceRequest = App.Http.Requests.Invoice.UpdateInvoiceRequest;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class InvoiceApi extends TenantBaseApi {
    async index(request: GetInvoicesRequest): Promise<GetInvoicesResponse> {
        return await this.get<GetInvoicesResponse, GetInvoicesRequest>("/invoices", {
            params: request,
        });
    }

    async show(invoiceId: string, request?: unknown): Promise<GetInvoiceResponse> {
        return await this.get<GetInvoiceResponse, unknown>(`/invoices/${invoiceId}`, {
            params: request,
        });
    }

    async store(request: StoreInvoiceRequest): Promise<GetInvoiceResponse> {
        return await this.post<GetInvoiceResponse, StoreInvoiceRequest>("/invoices", request);
    }

    async update(invoiceId: string, request: UpdateInvoiceRequest): Promise<GetInvoiceResponse> {
        return await this.patch<GetInvoiceResponse, UpdateInvoiceRequest>(`/invoices/${invoiceId}`, request);
    }

    async destroy(invoiceId: string): Promise<void> {
        return await this.delete<void>(`/invoices/${invoiceId}`);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/invoices/export", request);
    }
}

export const invoiceApi = new InvoiceApi();
